<template>
    <div class="jd-barchart-cont">
        <div class="jd-barchart" ref="barchart4"></div>
        <div class="jd-barchart" ref="barchart3"></div>
        <div class="jd-barchart" ref="barchart2"></div>
        <div class="jd-barchart" ref="barchart1"></div>
        <!-- <div class="jd-barchart" ref="barchart5"></div> -->
    </div>
</template>

<script>
import * as methods from "./method.js";

export default {
    name: "template.scope83",
    props: {
        vdata: {
            type: [Array, String],
            default: () => []
        },
        jsondata: {
            type: [Array, String],
            default: () => []
        },
        scopedata: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '一月', value2: '北京金蝶软件园', value3: '128', value4: '16', value5: '13', value6: '16' },
                { value1: '一月', value2: '上海金蝶软件园', value3: '19', value4: '14', value5: '15', value6: '19' },
                { value1: '一月', value2: '深圳金蝶云大厦', value3: '14', value4: '21', value5: '17', value6: '12' },
                { value1: '一月', value2: '长沙信创基地', value3: '21', value4: '18', value5: '19', value6: '21' },
                { value1: '二月', value2: '北京金蝶软件园', value3: '18', value4: '16', value5: '13', value6: '16' },
                { value1: '二月', value2: '上海金蝶软件园', value3: '14', value4: '12', value5: '17', value6: '11' },
                { value1: '二月', value2: '深圳金蝶云大厦', value3: '17', value4: '15', value5: '21', value6: '13' },
                { value1: '二月', value2: '长沙信创基地', value3: '13', value4: '13', value5: '12', value6: '15' },
            ],
            valueMap: [
                { name: '月份', key: 'value1' },
                { name: '地区名称', key: 'value2' },
                { name: '复看客户', key: 'value3' },
                { name: '新客户带看', key: 'value4' },
                { name: '有效商机', key: 'value5' },
                { name: '新增线索', key: 'value6' },
                // { name: '可出租面积', key: 'value7' },
            ],
            exceldata: [],
            apiconfig: {},
            isApi: false,
            scope: {},
            autoTimePaused: false,
        }
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
            }
        },
        jsondata(n) {
            this.exceldata = n
        },
        defaultdata(n) {
            this.DrawEcharts()
        }
    },
    methods: {
        ...methods,
        DrawEcharts() {
            clearInterval(this.timer)
            this.timer = null;
            let max = 0
            var echarts = require("echarts");
            var TmyChart1 = echarts.init(this.$refs.barchart1);
            var TmyChart2 = echarts.init(this.$refs.barchart2);
            var TmyChart3 = echarts.init(this.$refs.barchart3);
            var TmyChart4 = echarts.init(this.$refs.barchart4);
            // var TmyChart5 = echarts.init(this.$refs.barchart5);
            let charlist = [TmyChart1, TmyChart2, TmyChart3, TmyChart4]
            const colorList = [
                { color1: 'rgba(181,230,255)', color2: 'rgba(181,230,255,.1)' },
                { color1: 'rgba(0,227,226)', color2: 'rgba(0,227,226,.1)' },
                { color1: 'rgba(6,138,255)', color2: 'rgba(6,138,255,.1)' },
                { color1: 'rgba(28,233,110)', color2: 'rgba(28,233,110,.1)' },
                // { color1: 'rgba(28,233,210)', color2: 'rgba(28,233,210,.1)' },
            ]
            let xData = ['复看客户', '新客户带看', '有效商机', '新增线索']
            let vdata = JSON.parse(JSON.stringify(this.defaultdata))
            let xData2 = [...new Set(vdata.map(item => item.value2))]
            let xData3 = [...new Set(vdata.map(item => item.value1))]
            let chartlist = xData3.map(item => {
                let list = vdata.filter(del => del.value1 == item)
                return { name: item, data: list }
            })
            let series = xData.map((item, i) => {
                return {
                    realtimeSort: true,
                    name: item,
                    type: "bar",
                    label: {
                        show: true,
                    },
                    label: {
                        normal: {
                            align: "left",
                            position: [20, 2],
                            show: true, //关闭文字显示
                            textStyle: {
                                color: "#fff",
                                fontSize: 14,
                            },
                            formatter: function (params) {
                                return params.name + `(${params.value})`
                            },
                        },
                    },
                    barWidth: 15,
                    barGap: "50%",
                    itemStyle: {
                        normal: {
                            color: new echarts.graphic.LinearGradient(
                                1,
                                1,
                                0,
                                1,
                                [
                                    {
                                        offset: 0,
                                        color: colorList[i].color1, // 0% 处的颜色
                                    },
                                    // {
                                    //     offset: 0.6,
                                    //     color: "rgba(181,230,255)", // 0% 处的颜色
                                    // },
                                    {
                                        offset: 1,
                                        color: colorList[i].color2, // 100% 处的颜色
                                    },
                                ],
                                false
                            ),
                        },
                    },
                    data: chartlist[0].data.map(del => {
                        return {name: del.value2, value: del[`value${i + 3}`]}
                    })
                }
            })
            let valuelist = []
            series.forEach(item => {
                item.data.forEach(del => {
                    valuelist.push(del.value)
                })
            })
            max = Math.max(...valuelist)
            var Toption = {
                title: {
                    text: xData[0],
                    top: "45%",
                    left: "0",
                    textStyle: {
                        color: "#979AA0",
                        fontSize: 12,
                    },
                },
                tooltip: {
                    trigger: "axis",
                },
                grid: {
                    left: "70px",
                    right: "10px",
                    bottom: "0px",
                    top: "20px",
                    containLabel: true,
                },
                xAxis: {
                    type: "value",
                    splitNumber: 5,
                    splitLine: {
                        show: true,
                        lineStyle: {
                            type: "dashed",
                            color: "rgba(231,241,251,.2)",
                        },
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        show: false,
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                        },
                    },
                    max: max,
                },
                yAxis: {
                    type: "category",
                    z: 10,
                    data: xData2,
                    axisLabel: {
                        show: false,
                        interval: 0,
                        width: 60,
                        overflow: 'break', //文字超出宽度截断 换行
                        textStyle: {
                            color: "#bdc2cb", // 这里将 x 轴文本颜色设为红色
                            fontSize: "14",
                            lineHeight: 16,
                        },
                    },
                    axisLine: {
                        lineStyle: {
                            // X 轴颜色配置
                            color: "#4792e9",
                            // width: 1,
                        },
                    },
                    axisTick: {
                        show: false,
                    },
                    inverse: true,
                },
                // series: {...series}
            };
            let optionslist = []
            xData.forEach((item, i) => {
                charlist[i].clear()
                let options = JSON.parse(JSON.stringify(Toption))
                options.series = series[i]
                options.title.text = item
                if (i < 3) {
                    options.grid.top = '0'
                }
                optionslist.push(options)
                options && charlist[i].setOption(options)
            })
            let seriesindex = 1
            this.timer = setInterval(() => {
                if (seriesindex < chartlist.length) {
                    let chartdata = chartlist[seriesindex]
                    let datamaxlist = []
                    optionslist.forEach((item, i) => {
                        item.series.data.forEach(del => {
                            let finddata = chartdata.data.filter(arr => arr.value2 == del.name)[0]
                            if (finddata) {
                                del.value = +del.value + +finddata[`value${i + 3}`]
                                datamaxlist.push(del.value)
                            }
                        })
                        item = {...item}
                    })
                    let max = Math.max(...datamaxlist)
                    optionslist.forEach((item, i) => {
                        item.xAxis.max = max
                        charlist[i].setOption(item)
                    })
                    optionslist = [...optionslist]
                    seriesindex += 1
                } else {
                    clearInterval(this.timer)
                    this.timer = null
                }
            }, 2000);
            // TmyChart1.clear();
            // Toption && TmyChart1.setOption(Toption);
            // this.timer = setInterval(() => {
            //     if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
            //     TmyChart1.clear();
            //     Toption && TmyChart1.setOption(Toption);
            // }, 5000);
        }
    },
    mounted() {
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        if (this.jsondata && this.jsondata.length) {
            this.exceldata = this.jsondata;
        }
        this.setData()
        this.DrawEcharts()
    }
}
</script>

<style lang="scss" scoped>
.jd-barchart-cont {
    width: 435px;
    padding: 10px 0;
    position: relative;
    pointer-events: auto;
}
.jd-barchart {
    width: 435px;
    height: 135px;
}
</style>